export default __webpack_public_path__ + "static/media/polygon-chain.99f686b7.svg";